module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modalo",
    style: ('z-index:' + _vm.zIndex + ';')
  }, [(_vm.showClose) ? _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('icon', {
    attrs: {
      "name": "times-white",
      "scale": 5
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showClose) ? _c('Back', {
    attrs: {
      "text": _vm.closeText,
      "clicked": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "outer",
    on: {
      "click": _vm.closeFromOuterClick
    }
  }, [_c('div', {
    class: {
      'container': true, 'wide': _vm.wide, 'fullwide': _vm.fullwide
    },
    style: ({
      'max-width': _vm.width
    })
  }, [_c('div', {
    class: 'content ' + this.setClass,
    style: ({
      'min-width': _vm.minWidth,
      'width': _vm.normalWidth,
      'max-width': _vm.width
    }),
    attrs: {
      "id": "modal-container-content"
    }
  }, [_c('header', [_vm._t("header")], 2), _vm._v(" "), _c('main', [_vm._t("default")], 2), _vm._v(" "), _c('footer', [_vm._t("footer")], 2)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0913ad93"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/Modal.vue
// module id = 876
// module chunks = 0